export default __webpack_public_path__ + "static/media/Parrilla-orange.72557dd9.svg";